import type { ISVGIconProps } from "@ab.uitools/ui-library/components/SVGIcons/types";
import classNames from "classnames";

export const AMDSymbolIcon = ({
  size,
  type,
  className = "",
  onClick,
  refHandler,
  id,
  dataId,
}: ISVGIconProps) => {
  return (
    <svg
      className={classNames("svg-icon", {
        [`svg-icon__size-${size}`]: size,
        [`svg-icon__type-${type}`]: type,
        [className]: className,
      })}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      ref={refHandler}
      id={id}
      data-id={dataId ? `${dataId}-svg-icon` : ""}
    >
      <path
        d="M10.6115 4.00058C7.79329 4.00058 5.94055 6.11899 5.94055 8.67153V9.55667C5.94055 9.97088 6.27634 10.3067 6.69055 10.3067C7.10477 10.3067 7.44055 9.97088 7.44055 9.55667V8.67153C7.44055 6.89312 8.67499 5.50058 10.6115 5.50058C11.7642 5.50058 12.53 5.87566 13.0138 6.40495C13.5077 6.94547 13.7825 7.72964 13.7825 8.67153V11.5186H11.7545C11.3403 11.5186 11.0045 11.8544 11.0045 12.2686C11.0045 12.6829 11.3403 13.0186 11.7545 13.0186H13.7825V14.7013H11.7545C11.3403 14.7013 11.0045 15.0371 11.0045 15.4513C11.0045 15.8655 11.3403 16.2013 11.7545 16.2013H13.7825V19.252C13.7825 19.6662 14.1182 20.002 14.5325 20.002C14.9467 20.002 15.2825 19.6662 15.2825 19.252V16.2013H17.3095C17.7237 16.2013 18.0595 15.8655 18.0595 15.4513C18.0595 15.0371 17.7237 14.7013 17.3095 14.7013H15.2825V13.0186H17.3095C17.7237 13.0186 18.0595 12.6829 18.0595 12.2686C18.0595 11.8544 17.7237 11.5186 17.3095 11.5186H15.2825V8.67153C15.2825 7.44795 14.9239 6.27164 14.121 5.39305C13.3079 4.50324 12.1133 4.00058 10.6115 4.00058Z"
        fill="#888888"
      />
    </svg>
  );
};
